import coverIllus from "../assets/illustrations/guide/mental-noise/cover.svg";
import whatIsIllus from "../assets/illustrations/guide/mental-noise/what-is.svg";
import sourcesIllus from "../assets/illustrations/guide/mental-noise/sources.svg";
import internalVsExternalIllus from "../assets/illustrations/guide/mental-noise/internal-vs-external.svg";
import vsOverthinkingIllus from "../assets/illustrations/guide/mental-noise/vs-overthinking.svg";
import anxietyIllus from "../assets/illustrations/guide/mental-noise/anxiety.svg";
import brainWontLetGoIllus from "../assets/illustrations/guide/mental-noise/brain-wont-let-go.svg";
import beforeSleepIllus from "../assets/illustrations/guide/mental-noise/before-sleep.svg";
import reducingIllus from "../assets/illustrations/guide/mental-noise/reducing.svg";

export const MENTAL_NOISE_COVER = {
  banner: "Quiet the noise",
  illustration: coverIllus,
  illustrationAlt: "Head surrounded by swirling thought lines",
};

export const MENTAL_NOISE_ACCENTS = ["amber", "electric", "fuchsia", "mint"];

export const MENTAL_NOISE_SECTION_VISUALS = {
  "what-is-mental-noise": {
    illustration: whatIsIllus,
    illustrationAlt: "Tangled thought threads inside a silhouette",
    banner: "Name the noise",
  },
  "sources-of-mental-noise": {
    illustration: sourcesIllus,
    illustrationAlt: "Multiple streams feeding into a cluttered mind",
    banner: "Trace the sources",
  },
  "internal-vs-external": {
    illustration: internalVsExternalIllus,
    illustrationAlt: "Split view of outer distractions and inner chatter",
    banner: "Inside and outside",
  },
  "mental-noise-vs-overthinking": {
    illustration: vsOverthinkingIllus,
    illustrationAlt: "Background static compared to a focused thought loop",
    banner: "Know the difference",
  },
  "mental-noise-and-anxiety": {
    illustration: anxietyIllus,
    illustrationAlt: "Circular arrows between a racing mind and tense body",
    banner: "The anxiety cycle",
  },
  "why-your-brain-wont-let-go": {
    illustration: brainWontLetGoIllus,
    illustrationAlt: "Brain replaying a looping film reel",
    banner: "Letting go",
  },
  "mental-noise-before-sleep": {
    illustration: beforeSleepIllus,
    illustrationAlt: "Pillow surrounded by floating thought bubbles at night",
    banner: "Nighttime quiet",
  },
  "reducing-mental-noise": {
    illustration: reducingIllus,
    illustrationAlt: "Volume knob turning down on scattered thoughts",
    banner: "Turn it down",
  },
};

export function getMentalNoiseSectionVisual(sectionId) {
  return MENTAL_NOISE_SECTION_VISUALS[sectionId] || null;
}

export function getMentalNoiseAccent(index) {
  return MENTAL_NOISE_ACCENTS[index % MENTAL_NOISE_ACCENTS.length];
}
